import React, { useState, useEffect, useContext, useMemo } from "react";
import checklistContext from "../../context/checklistContext/checklistContext";
import TareasSubtabla from "../tareasSubtabla/TareasSubtabla";

import Select from 'react-select';
import Swal from 'sweetalert2'

import { estructuraChecklist, estructuraTarea } from "../../utils/estructuras";
import activoTypeContext from "../../context/activoTypeContex/activoTypeContex";
import authContext from "../../context/authentication/authContex";


import './FormChecklist.css';
import ControlesSubtabla from "../controlestSubtabla/ControlesSubtabla";
import ImagenInteractivaPreviewCK from "../imagenInteractivaPreviewCK/ImagenInteractivaPreviewCK";
import controlContext from "../../context/controlesContext/controlContex";

const FormChecklist = ({ checklistToModify, setShowABM, setChecklistToModify, actualizarChecklistList }) =>{

    const ckContext = useContext(checklistContext);
    const {agregarChecklist,modificarChecklist} = ckContext;

    const {controlList} = useContext(controlContext);

    const [checklist, setChecklist] = useState((Object.keys(checklistToModify).length > 0) ? {...checklistToModify} : {...estructuraChecklist});
    const [mode,setMode] = useState((Object.keys(checklistToModify).length > 0 && checklistToModify.fromActivo == undefined) ? 'edit' : 'new'); 
    const [tablaSeleccionada,setTablaSeleccionada] = useState("controles"); //Estado que indica que tabla hija renderizar.
    const [options,setOptions] = useState({activosType:[]}) //Estado que almacena todas las opciones seleccionables en los SelectControl.
    
    const [imageSrc, setImageSrc] = useState(checklistToModify?.imgUrl ?? null);
    const [imageSrc2, setImageSrc2] = useState(checklistToModify?.imgUrl2 ?? null);
    const [file, setFile] = useState(null);
    const [file2, setFile2] = useState(null);

    const atContext = useContext(activoTypeContext);
    const {activoTypeList} = atContext;

    const { usuario } = useContext(authContext);

    const optionsCtrls = useMemo(()=> (controlList && controlList.length > 0) ? controlList.map(c => ({label: c.name, value: c.codigo, id: c._id, descrp: c.descrp, name: c.name, showDescrp: c.showDescrp})) : [],[controlList]);
    
    const createOptions = () =>{
        if(activoTypeList != undefined){
            let optionsActivos = activoTypeList.map((a) =>  { return {value:a.codTypeActivo,label:a.nameTypeActivo}});
            setOptions({...options,['activosType']:optionsActivos});
        }
    }

    const handleChange = (e,property=null,value=null) =>{
        if(property !== null && value !== null){
            //removeCampoVacio(property);
            setChecklist(prevChecklist => {
                const newChecklist = {...prevChecklist,[property]:value};
                return newChecklist;
            })
        }else{
            if(e.target.value == ""){
               
            }
            const checkboxFields = ['visualizarCrono', 'solicitaCantCombustible', 'solicitarCantCombustibleGeneral', 'solicitarCantCombustiblePreciso', 'solicitarDuracionCarga', 'solicitarSector', 'solicitarImputacionesRRHH', 'solicitarLecturasActivo', 'disponibleParaMecanicos', 'uniqueRead'];
            if(checkboxFields.includes(e.target.name)){
                const updates = { [e.target.name]: e.target.checked };
                if(e.target.name === 'solicitarCantCombustibleGeneral' && e.target.checked) updates.solicitarCantCombustiblePreciso = false;
                if(e.target.name === 'solicitarCantCombustiblePreciso' && e.target.checked) updates.solicitarCantCombustibleGeneral = false;
                setChecklist({...checklist, ...updates});
            }
            else setChecklist({...checklist,[e.target.name]:e.target.value})
        }
    }

    const eliminarRelacionesIncompletas = (checkToSave) =>{
        let controlesCompletados = checkToSave.controles.filter(c => c.label != '');
        
        if(checkToSave.codigo == '' || checkToSave.name == ''){
            return {state: false, codeError:'emptyFields'};
        }
        if(controlesCompletados.length == 0){
            return {state: false, codeError:'CTRLS0'};
        }

        controlesCompletados.map(c => ({...c, userName: usuario.userName, comUserID: usuario._id}));

        if(checkToSave.tipAct.length > 0){
            let activos = checkToSave.tipAct.slice(); 
            checkToSave.tipAct = activos.map((a) => a.value).join(' , '); 
            checkToSave.activos = checkToSave.tipAct[0].label; 
        }else checkToSave.tipAct = '';

        checkToSave.controles = controlesCompletados;

        return {state:true};
    }

    const handleSaveChecklist = async() =>{
        let checklistToSave = {...checklist};
        
        let validaciones = eliminarRelacionesIncompletas(checklistToSave);

        if(validaciones.state){
            agregarChecklist(checklistToSave, file, file2)
            .then(res => {
                if(res == 'DUPLICATEKEY') Swal.fire({
                    title: `Ya existe un procedimiento con ese codigo`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowEnterKey: true
                })
                else if(res != undefined){
                    Swal.fire({
                        title: `Se guardo una nueva checklist`,
                        icon: 'success',
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    setShowABM(true);
                    setChecklist({...estructuraChecklist})
                }
            })
            .catch(err => {
                console.log("error en FormChecklist, funcion handleSaveChecklist");
                console.log(err);
            })
        }else{
            Swal.fire({
                title: "Imposible guardar!",
                icon: 'error',
                text: validaciones.codeError == 'CTRLS0' ? "El Checklist debe tener al menos un control" : "Compruebe que el codigo y el nombre del checklist esten completado",
                showConfirmButton: true,
                allowEnterKey: true
            })
        }
    }
    
    const handleUpdateChecklist = async () =>{
        let checklistToUpload = {...checklist}
        try {
            let validaciones = eliminarRelacionesIncompletas(checklistToUpload);

            if(validaciones.state){
                let res = await modificarChecklist(checklistToUpload, file, file2);
                if(res.codigo != undefined){
                    Swal.fire({
                        title: `Se modificó checklist ${res.name}`,
                        icon: 'success',
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    setChecklistToModify({});
                    setShowABM(true);
                }else{
                    Swal.fire({
                        title: res.message,
                        icon: 'error',
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    setChecklist({...estructuraChecklist});
                    setChecklistToModify({});
                    setShowABM(true);
                    actualizarChecklistList();
                }
            }else{
                Swal.fire({
                    title: "Imposible guardar!",
                    icon: 'error',
                    text: validaciones.codeError == 'CTRLS0' ? "El Checklist debe tener al menos un control" : "Compruebe que el codigo y el nombre del checklist esten completado",
                    showConfirmButton: true,
                    allowEnterKey: true
                })
            }
        } catch (error) {

        }
    }

    const handleClickCancel = () =>{
        Swal.fire({
            title: 'Está seguro que desea cancelar?',
            showDenyButton: true,
            confirmButtonText: 'Sí, Cancelar',
            confirmButtonColor: '#ff0000',
            denyButtonColor: '#3d4d87',
            denyButtonText: 'No',
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                actualizarChecklistList();
                setShowABM(true);                
                setChecklistToModify({});
            } 
        })
    }

    useEffect(() => {
        if(mode == 'edit'){
            //Si no tienen valores seteados y fue guardado igual, se setearan los iniciales vacios.
            let activosFiltered = [];   
            let controles = [{...estructuraTarea}]      
            
            if(checklistToModify.tipAct != '' && checklistToModify.tipAct != undefined){
                //Separa los tipos de activos obtenidos en cadena String en elementos de un array
                let activosAlreadySelected = checklistToModify.tipAct.split(",").map((a) => a.trim()); 
                //Por el codigo de tipo activo trae toda su info filtrada
                activosFiltered = activoTypeList.filter((a) => activosAlreadySelected.includes(a.codTypeActivo)); 
                //Crea las opciones ya seleccionadas para el select control.
                activosFiltered = activosFiltered.map((a) => { return {value:a.codTypeActivo,label:a.nameTypeActivo}}) 
            }
            
            if(checklistToModify.controles != undefined && checklistToModify.controles.length > 0){
                controles = checklistToModify.controles.map((c) => (c.codigo != undefined) ? {descrp: c.descrp, showDescrp: c.showDescrp, value: c.codigo, id: c.id, name: c.name, label:c.name, taskDescrp:c.taskDescrp, fecMod: c.fecMod, fecAlt: c.fecAlt, relacionId: c.controlXchecklistID, x: c.x, y: c.y, imgNro: c.imgNro, noDisparaProc: c.noDisparaProc ?? false} : {...c})
                controles.push({...estructuraTarea});
            }

            setChecklist({...checklist,controles:controles,tipAct:activosFiltered});
        }
    },[checklistToModify]);

    useEffect(()=>{ 
        //useEffect que al recibir los activos, modela sus valores para adaptarlos al Select Multiple Valor.
        createOptions()
    },[activoTypeList]);

    return <div className="checklistForm">
    <div className="checklistHeaderForm">
        <div className="inputGroup">
            <label>Codigo</label>
            <input name="codigo" value={checklist.codigo} onChange={e => handleChange(e)}/>
        </div>
        <div className="inputGroup">
            <label>Nombre</label>
            <input name="name" value={checklist.name} onChange={e => handleChange(e)}/>
        </div>
    </div>
    
    <div className="inputGroup" id="inputGroupMultiSelect">
        <label>Tipo Activo</label>
        <Select
            styles={{
                container: base => ({
                    ...base,
                    flexGrow:1,
                    width:'60%'
                }),
                multiValueLabel: (base) => ({
                ...base,
                boxShadow:"none !important",
                backgroundColor: "#6b9080",
                color: 'white',
                borderRadius: "none",
                fontSize: "1rem",
                width:'100%',

                }), 
                multiValueRemove: (base) => ({
                    ...base,
                    backgroundColor: "#6b9080",
                    color: 'white',
                    borderRadius: "none",
                    fontSize: "1rem"
                }),
            }}
            isMulti
            placeholder=""
            options={options.activosType}
            value={checklist.tipAct}
            onChange={(value)=>handleChange(null,"tipAct",value)}
        />
    </div>

    <div className="inputGroup">
        <label>Visualiza cronometro</label>
        <input type="checkbox" onClick={(e)=>handleChange(e)} checked={(checklist.visualizarCrono && checklist.visualizarCrono == true) ? true : false} name="visualizarCrono"/>
    </div>
    <div className="inputGroup">
        <label>Disponible para Mecánicos</label>
        <input type="checkbox" onClick={(e)=>handleChange(e)} checked={checklist.disponibleParaMecanicos === true} name="disponibleParaMecanicos"/>
    </div>

    <div className="infoAdicionalDiv">
        <h4>Solicitar información Adicional</h4>
        <div className="solicitarAlRow">
            <div className="inputGroup">
                <label>Solicitar al...</label>
                <Select
                    styles={{
                        container: base => ({
                            ...base,
                            width: '200px'
                        }),
                    }}
                    placeholder="Seleccione"
                    options={[{value:'comenzar', label:'Comenzar'}, {value:'finalizar', label:'Finalizar'}]}
                    value={checklist.solicitarInfoMomento ? {value: checklist.solicitarInfoMomento, label: checklist.solicitarInfoMomento === 'comenzar' ? 'Comenzar' : 'Finalizar'} : null}
                    onChange={(option)=>handleChange(null,"solicitarInfoMomento", option ? option.value : null)}
                />
            </div>
            <div className="inputGroup solicitarAlCheckbox">
                <label>Unica Lectura</label>
                <input type="checkbox" onClick={(e)=>handleChange(e)} checked={checklist.uniqueRead === true} name="uniqueRead"/>
            </div>
        </div>
        <div className="infoAdicionalContainer">
            <div className="inputGroup infoAdicionalItem">
                <label>Cantidad Combustible - General</label>
                <input type="checkbox" onClick={(e)=>handleChange(e)} checked={checklist.solicitarCantCombustibleGeneral === true} name="solicitarCantCombustibleGeneral"/>
            </div>
            <div className="inputGroup infoAdicionalItem">
                <label>Cantidad Combustible - Precisa</label>
                <input type="checkbox" onClick={(e)=>handleChange(e)} checked={checklist.solicitarCantCombustiblePreciso === true} name="solicitarCantCombustiblePreciso"/>
            </div>
            <div className="inputGroup infoAdicionalItem">
                <label>Duración de la Carga</label>
                <input type="checkbox" onClick={(e)=>handleChange(e)} checked={checklist.solicitarDuracionCarga === true} name="solicitarDuracionCarga"/>
            </div>
            {/* <div className="inputGroup infoAdicionalItem">
                <label>Sector</label>
                <input type="checkbox" onClick={(e)=>handleChange(e)} checked={checklist.solicitarSector === true} name="solicitarSector"/>
            </div> */}
            <div className="inputGroup infoAdicionalItem">
                <label>Imputaciones RRHH</label>
                <input type="checkbox" onClick={(e)=>handleChange(e)} checked={checklist.solicitarImputacionesRRHH === true} name="solicitarImputacionesRRHH"/>
            </div>
            <div className="inputGroup infoAdicionalItem">
                <label>Lecturas Activo</label>
                <input type="checkbox" onClick={(e)=>{
                    if (e.target.checked) {
                        setChecklist(prev => ({...prev, solicitarLecturasActivo: true}));
                    } else {
                        setChecklist(prev => ({...prev, solicitarLecturasActivo: false, uniMed: null, uniMedExtra: null}));
                    }
                }} checked={checklist.solicitarLecturasActivo === true} name="solicitarLecturasActivo"/>
            </div>
        </div>
        <div className="infoAdicionalRow">
            <div className="inputGroup infoAdicionalItem">
                <label>Solicitar Lectura</label>
                <Select
                    styles={{
                        container: base => ({
                            ...base,
                            width: '200px'
                        }),
                    }}
                    placeholder="No solicitar"
                    isClearable
                    options={[{value:'KM', label:'Kilómetros'}, {value:'HS', label:'Horas'}, {value:'HSsec', label:'Horas Secundarias'}]}
                    value={checklist.uniMed ? {value: checklist.uniMed, label: checklist.uniMed === 'KM' ? 'Kilómetros' : checklist.uniMed === 'HS' ? 'Horas' : 'Horas Secundarias'} : null}
                    onChange={(option)=>{
                        const newUniMed = option ? option.value : null;
                        setChecklist(prev => ({
                            ...prev,
                            uniMed: newUniMed,
                            uniMedExtra: (!newUniMed || prev.uniMedExtra === newUniMed) ? null : prev.uniMedExtra,
                            ...(newUniMed && { solicitarLecturasActivo: true })
                        }));
                    }}
                />
            </div>
            <div className="inputGroup infoAdicionalItem">
                <label>Solicitar Lectura Extra</label>
                <Select
                    styles={{
                        container: base => ({
                            ...base,
                            width: '200px'
                        }),
                    }}
                    placeholder="No solicitar"
                    isClearable
                    isDisabled={!checklist.uniMed}
                    options={[{value:'KM', label:'Kilómetros'}, {value:'HS', label:'Horas'}, {value:'HSsec', label:'Horas Secundarias'}].filter(o => o.value !== checklist.uniMed)}
                    value={checklist.uniMedExtra ? {value: checklist.uniMedExtra, label: checklist.uniMedExtra === 'KM' ? 'Kilómetros' : checklist.uniMedExtra === 'HS' ? 'Horas' : 'Horas Secundarias'} : null}
                    onChange={(option)=> setChecklist(prev => ({...prev, uniMedExtra: option ? option.value : null}))}
                />
            </div>
        </div>
    </div>

    <ImagenInteractivaPreviewCK imageSrc={imageSrc} setImageSrc={setImageSrc} imageSrc2={imageSrc2} setImageSrc2={setImageSrc2} file={file} setFile={setFile} file2={file2} setFile2={setFile2} optionsCtrls={optionsCtrls} handleChange={handleChange} controles={checklist.controles}/>

    <div className="tablasHijasDiv">
        <div className="opcionesHijasDiv">
            <button className={(tablaSeleccionada === 'controles') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('controles')}>Controles</button>
        </div>
        <ControlesSubtabla controles={checklist.controles} setState={setChecklist} tablaSeleccionada={tablaSeleccionada} tipo={'checkList'} checklistID={checklist._id} componentePadre={"FormChecklist"}/> 
    </div>

    <div className="functionsDiv">
        {(mode == 'new') ? <button className="saveProcBtn" onClick={handleSaveChecklist}>Guardar</button> : <button className="saveProcBtn" onClick={()=>handleUpdateChecklist()}>Guardar cambios</button>}
        <button className="cancelProcBtn" onClick={()=>handleClickCancel()}>Cancelar</button>
    </div>
</div>

}

export default FormChecklist;